var ConfigServiceItem = /** @class */ (function () {
    function ConfigServiceItem() {
        var config = this.getConfig("/assets/config.json");
        this.config = config || null;
    }
    ConfigServiceItem.prototype.get = function (key, hideNotification) {
        var _a;
        var val = (_a = this.config) === null || _a === void 0 ? void 0 : _a[key];
        if (val !== undefined) {
            return val;
        }
        !hideNotification && console.warn("option ".concat(key, " not defined"));
    };
    ConfigServiceItem.prototype.getConfig = function (theUrl) {
        try {
            var xmlHttp = new XMLHttpRequest();
            xmlHttp.open('GET', theUrl, false);
            xmlHttp.send(null);
            if (xmlHttp.status !== 200)
                throw new Error("Failed to load config: HTTP status ".concat(xmlHttp.status));
            if (!xmlHttp.responseText)
                throw new Error('Empty response received');
            return JSON.parse(xmlHttp.responseText);
        }
        catch (error) {
            console.warn(error);
        }
    };
    return ConfigServiceItem;
}());
export { ConfigServiceItem };
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        if (!ConfigService.appConfig) {
            ConfigService.appConfig = new ConfigServiceItem();
        }
        return ConfigService.appConfig;
    }
    return ConfigService;
}());
export { ConfigService };
export var configServiceInstance = new ConfigService();
